import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('charging-treasure', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.085 35L38.9573 8.64644C38.7782 7.13694 37.4983 6 35.9782 6H12.9425C11.4569 6 10.195 7.08729 9.97542 8.55657L6.02344 35",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "30",
    width: "36",
    height: "12",
    rx: "6",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("rect", {
    x: "19",
    y: "34",
    width: "4",
    height: "4",
    rx: "2",
    fill: props.colors[2]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 36H35",
    stroke: props.colors[2],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H26",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});